import { LocalStorageKeys } from '../../../../../enums/localStorageKeys'
import { AdvisorLayerMode } from '../enums/advisorLayerMode'
import { isAdvisorLayerMode } from './isAdvisorLayerMode'

export const readStoredMode = (): AdvisorLayerMode | undefined => {
  try {
    const raw = globalThis.localStorage.getItem(LocalStorageKeys.AdvisorLayerMode)
    return isAdvisorLayerMode(raw) ? raw : undefined
  } catch {
    return undefined
  }
}

export const writeStoredMode = (mode: AdvisorLayerMode): void => {
  try {
    globalThis.localStorage.setItem(LocalStorageKeys.AdvisorLayerMode, mode)
  } catch {
    // Ignore storage errors (quota, private mode, etc.) — in-memory state stays correct.
  }
}
